import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';

import { type PostOfficeContextConfig } from '../../post-office-context/types';

/**
 * There are certain conditions, eg. Baseline Criterion tests, where products want to disable all Post Office Placements.
 * NOT to be used in Prod.
 */
export const isPostOfficePlacementsGloballyDisabled = (
	context: PostOfficeContextConfig,
): boolean => {
	// Only evaluate the config when the host opts in, so placements that never
	// set disableAllPlacements don't touch Statsig at all.
	if (context.disableAllPlacements !== true) {
		return false;
	}

	// This operational config must not emit experiment exposures.
	return (
		UNSAFE_expValNoExposure('post-office_placements_global-disable-check', 'value', false) === true
	);
};
